import { createContext, useContext, useEffect } from "react";
import { type Locale, translations, LOCALE_TO_HTML_LANG } from "./translations";

type LanguageContextType = {
  locale: Locale;
  t: (key: string) => string;
};

const LanguageContext = createContext<LanguageContextType>({
  locale: "no",
  t: (key) => key,
});

export const LanguageProvider = ({
  locale,
  children,
}: {
  locale: Locale;
  children: React.ReactNode;
}) => {
  const t = (key: string): string => {
    return translations[locale]?.[key] ?? translations["no"]?.[key] ?? key;
  };

  useEffect(() => {
    document.documentElement.lang = LOCALE_TO_HTML_LANG[locale];
  }, [locale]);

  return (
    <LanguageContext.Provider value={{ locale, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);
